
export const SvgIcons = [
  'next-page', 'next-page-arrow', 'settings', 'reset',
  'next-page-arrow-curve', 'excel', 'pdf', 'ms-word', 'columns', 'page-break', 'add', 'edit', 'view', 'send', 'email',
  'person', 'logout', 'close', 'menu', 'loan', 'option', 'search', 'copy', 'empty', 'document', 'bug', 'translate',
  'download', 'legal', 'workers', 'check', 'password', 'notification', 'phone', 'back-arrow',
  'color-farmer', 'color-provider', 'color-certificate', 'color-statistics'
];
